(() => {
  const menu = document.querySelector('[data-mobile-menu]');
  const openButton = document.querySelector('[data-menu-toggle]');
  const closeButton = document.querySelector('[data-menu-close]');

  const openMenu = () => {
    if (!menu) return;
    menu.hidden = false;
    openButton?.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  };
  const closeMenu = () => {
    if (!menu) return;
    menu.hidden = true;
    openButton?.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  };

  openButton?.addEventListener('click', openMenu);
  closeButton?.addEventListener('click', closeMenu);
  menu?.querySelectorAll('a').forEach(link => link.addEventListener('click', closeMenu));
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') closeMenu();
  });

  document.querySelectorAll('[data-product-thumb]').forEach(button => {
    button.addEventListener('click', () => {
      const id = button.dataset.productThumb;
      const gallery = button.closest('.product-gallery');
      gallery?.querySelectorAll('[data-product-media]').forEach(media => media.classList.toggle('is-active', media.dataset.productMedia === id));
      gallery?.querySelectorAll('[data-product-thumb]').forEach(thumb => thumb.classList.toggle('is-active', thumb === button));
    });
  });

  document.addEventListener('click', event => {
    const button = event.target.closest('[data-pnc-gallery-image]');
    if (!button) return;

    const gallery = button.closest('.pnc-product__gallery');
    const mainImage = gallery?.querySelector('[data-pnc-main-image]');
    const nextSrc = button.dataset.pncGalleryImage;
    if (!mainImage || !nextSrc) return;

    mainImage.removeAttribute('srcset');
    mainImage.removeAttribute('sizes');
    mainImage.src = nextSrc;
    mainImage.alt = button.dataset.pncGalleryAlt || mainImage.alt || '';

    gallery.querySelectorAll('[data-pnc-gallery-image]').forEach(thumb => {
      const active = thumb === button;
      thumb.classList.toggle('is-active', active);
      thumb.setAttribute('aria-current', active ? 'true' : 'false');
    });
  });

  const addCrunchyPawsToHome = async () => {
    const grid = document.querySelector('.pch-products .pch-product-grid');
    if (!grid || grid.querySelector('[data-pch-crunchy-paws]')) return;

    try {
      const response = await fetch('/products/crunchy-paws-patitas-de-pollo-deshidratadas-6-piezas.js', { credentials: 'same-origin' });
      if (!response.ok) return;
      const product = await response.json();
      const href = '/products/crunchy-paws-patitas-de-pollo-deshidratadas-6-piezas';
      const image = product.featured_image || product.images?.[0];
      if (!image) return;

      const article = document.createElement('article');
      article.className = 'pch-product';
      article.setAttribute('data-pch-crunchy-paws', '');
      article.innerHTML = `
        <a class="pch-product__media" href="${href}">
          <img src="${image}" loading="lazy" alt="Crunchy Paws, patitas crujientes de pollo para perro">
        </a>
        <div class="pch-product__body">
          <p class="pch-kicker">PATITAS CRUJIENTES · 6 PIEZAS</p>
          <h3><a href="${href}">Crunchy Paws</a></h3>
          <p>Textura crujiente para disfrutar un premio que dura un poquito más.</p>
          <div><strong>$ ${Math.round(product.price / 100).toLocaleString('es-MX')}</strong><a href="${href}">Ver producto </a></div>
        </div>`;
      grid.appendChild(article);

      const heading = document.querySelector('.pch-products .pch-heading h2');
      if (heading) heading.textContent = 'Cinco premios. Cinco formas de consentirlo.';

      if (!document.getElementById('pch-five-product-grid')) {
        const style = document.createElement('style');
        style.id = 'pch-five-product-grid';
        style.textContent = '@media (min-width:1081px){.pch-products .pch-product-grid{grid-template-columns:repeat(5,minmax(0,1fr));}}';
        document.head.appendChild(style);
      }
    } catch (_) {
      // Keep the existing four-card section if the product request fails.
    }
  };
  addCrunchyPawsToHome();

  document.querySelectorAll('[data-product-form]').forEach(form => {
    const optionInputs = [...form.querySelectorAll('[data-product-option]')];
    const variantSelect = form.querySelector('[data-variant-select]');
    const price = document.querySelector('[data-product-price]');
    if (!variantSelect || optionInputs.length === 0) return;

    const syncVariant = () => {
      const selectedOptions = optionInputs.map(input => input.value);
      const match = [...variantSelect.options].find(option => {
        try {
          return JSON.stringify(JSON.parse(option.dataset.options)) === JSON.stringify(selectedOptions);
        } catch (_) {
          return false;
        }
      });
      if (match) {
        variantSelect.value = match.value;
        if (price && match.dataset.price) price.textContent = match.dataset.price;
      }
    };
    optionInputs.forEach(input => input.addEventListener('change', syncVariant));
  });

  const toast = document.querySelector('[data-toast]');
  const showToast = message => {
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add('is-visible');
    window.clearTimeout(showToast.timer);
    showToast.timer = window.setTimeout(() => toast.classList.remove('is-visible'), 2600);
  };

  document.addEventListener('submit', event => {
    if (event.target.matches('.newsletter-form')) showToast('Gracias por unirte al Natural Club.');
  });
})();
